/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Language_Switcher_CurrentInputs */

const en_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Language: ${i?.language}`)
};

const zh_hans1_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`语言：${i?.language}`)
};

const pt_br2_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Idioma: ${i?.language}`)
};

const es_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Idioma: ${i?.language}`)
};

const fr_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langue : ${i?.language}`)
};

const de_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprache: ${i?.language}`)
};

const ru_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Язык: ${i?.language}`)
};

const it_language_switcher_current = /** @type {(inputs: Language_Switcher_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lingua: ${i?.language}`)
};

/**
* | output |
* | --- |
* | "Language: {language}" |
*
* @param {Language_Switcher_CurrentInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const language_switcher_current = /** @type {((inputs: Language_Switcher_CurrentInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switcher_CurrentInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_language_switcher_current(inputs)
	if (locale === "pt-BR") return pt_br2_language_switcher_current(inputs)
	if (locale === "es") return es_language_switcher_current(inputs)
	if (locale === "fr") return fr_language_switcher_current(inputs)
	if (locale === "de") return de_language_switcher_current(inputs)
	if (locale === "ru") return ru_language_switcher_current(inputs)
	if (locale === "it") return it_language_switcher_current(inputs)
	return en_language_switcher_current(inputs)
});